export const PillIcon = ({ width = 24, height = 24, color = '#667085' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Pill capsule outline */}
    <path
      d="M8.5 8.5H15.5C17.433 8.5 19 10.067 19 12C19 13.933 17.433 15.5 15.5 15.5H8.5C6.567 15.5 5 13.933 5 12C5 10.067 6.567 8.5 8.5 8.5Z"
      stroke={color}
      strokeWidth="1.5"
    />
    {/* Center divider */}
    <path
      d="M12 8.5V15.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
